import { Type, type Static } from "@sinclair/typebox";
import {
  DOCUMENT_VIEW_RESULT_MAX_LIMIT,
  DocumentDateSchema,
  DocumentTimeZoneSchema,
  DocumentTimestampSchema
} from "../document-organization.ts";
import { DocumentTagKeySchema } from "../document-tags.ts";
import {
  DOCUMENT_VIEW_SCHEMA_VERSION,
  DocumentViewCreateProperties,
  DocumentViewCursorSchema,
  DocumentViewRecordProperties,
  DocumentViewResultDocumentSchema,
  DocumentViewUpdateProperties
} from "./common.ts";

export const TimelineDateFieldSchema = Type.Union([
  Type.Object(
    { source: Type.Literal("core"), field: Type.Literal("createdAt") },
    { additionalProperties: false }
  ),
  Type.Object(
    {
      source: Type.Literal("tag"),
      key: DocumentTagKeySchema,
      valueType: Type.Union([Type.Literal("date"), Type.Literal("datetime")])
    },
    { additionalProperties: false }
  )
]);
export type TimelineDateFieldV2 = Static<typeof TimelineDateFieldSchema>;

export const TimelineConfigurationSchema = Type.Object(
  {
    dateField: TimelineDateFieldSchema,
    timezone: DocumentTimeZoneSchema
  },
  { additionalProperties: false }
);
export type TimelineConfigurationV2 = Static<typeof TimelineConfigurationSchema>;

export const TimelineDocumentViewSchema = Type.Object(
  {
    ...DocumentViewRecordProperties,
    viewType: Type.Literal("timeline"),
    configuration: TimelineConfigurationSchema
  },
  { additionalProperties: false }
);
export type TimelineDocumentViewV2 = Static<typeof TimelineDocumentViewSchema>;

export const TimelineDocumentViewCreateInputSchema = Type.Object(
  {
    ...DocumentViewCreateProperties,
    viewType: Type.Literal("timeline"),
    configuration: TimelineConfigurationSchema
  },
  { additionalProperties: false }
);

export const TimelineDocumentViewUpdateInputSchema = Type.Object(
  {
    ...DocumentViewUpdateProperties,
    viewType: Type.Literal("timeline"),
    configuration: TimelineConfigurationSchema
  },
  { additionalProperties: false }
);

export const TimelineEntrySchema = Type.Object(
  {
    document: DocumentViewResultDocumentSchema,
    occurredAt: DocumentTimestampSchema,
    bucketDate: DocumentDateSchema
  },
  { additionalProperties: false }
);

export const TimelineDocumentViewResultSchema = Type.Object(
  {
    schemaVersion: Type.Literal(DOCUMENT_VIEW_SCHEMA_VERSION),
    viewType: Type.Literal("timeline"),
    viewId: Type.String({ format: "uuid" }),
    viewRevision: Type.Integer({ minimum: 0 }),
    entries: Type.Array(TimelineEntrySchema, { maxItems: DOCUMENT_VIEW_RESULT_MAX_LIMIT }),
    undatedCount: Type.Integer({ minimum: 0 }),
    nextCursor: DocumentViewCursorSchema
  },
  { additionalProperties: false }
);
export type TimelineDocumentViewResultV2 = Static<typeof TimelineDocumentViewResultSchema>;
